import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import './App.css';
import routes from './routes';
import { History } from 'history';
import 'moment/min/locales';

interface AppProps {
  history: History;
}

const App = ({ history }: AppProps) => {
  return <ConnectedRouter history={history}>{routes}</ConnectedRouter>;
};

export default App;
